import { Alert, Box, Button, Typography } from "@mui/material";
import { useForm } from "react-hook-form";

const { Wrapper } = require("@googlemaps/react-wrapper");
const { useState, useEffect } = require("react");
const { default: GoogleMap } = require("../../../maps/GoogleMap");
const { default: GoogleMapMarker } = require("../../../maps/GoogleMapMarker");
const { default: MarkerControl } = require("../MarkerControl");

const env = process.env.REACT_APP_ENV;
const envConfig = require(`../../../../config/config.${env}.json`);

const defaultCenterLat = -35.7464
const defaultCenterLng = 174.3094
// 0000575085NR81D

export default function IcpInspectionStepLocation({ formState: { markerLatLng }, dispatch, onNext, address, initialZoom }) {

    const [zoom, setZoom] = useState(initialZoom)
    const [center, setCenter] = useState({ lat: markerLatLng.lat || defaultCenterLat, lng: markerLatLng.lng || defaultCenterLng })
    const [error, setError] = useState(false)

    const useFormObject = useForm()
    const { handleSubmit, formState: { errors }, watch } = useFormObject
    const watchingLatLng = watch(['lat', 'lng'])
    console.log('watchingLatLng: ', watchingLatLng)

    const googleMapsLatLng = { lat: markerLatLng.lat * 1, lng: markerLatLng.lng * 1 }
    const render = (status) => {
        return <h4>Google Map: {status}</h4>
    }

    const onSubmit = (data) => {
        console.log('IcpInspectionStepLocation onSubmit passed validation with data', data)
        if ((data.lat === -35.73214300000001 && data.lng === 174.3095415) || (data.lat === -35.7464 && data.lng === 174.3094)) {
            setError(true)
        } else {
            onNext(data)
        }
    }

    const onIdle = (m) => { // google.maps.Map
        setZoom(m.getZoom());
        setCenter(m.getCenter().toJSON());
    };

    /**
     * 
     * @param {*} newLatLng e.g. {lat: -35, lng: 174}
     */
    const handleUseLocation = (newLatLng) => {
        console.log('handleUseLocation newLatLng', newLatLng)
        if (newLatLng.lat === -35.73214300000001 && newLatLng.lng === 174.3095415) {
            setError(true)
        }
        setCenter(newLatLng)
        setZoom(17)
        dispatchLatLng(newLatLng)
    }

    const handleBringPinToCenter = () => {
        // console.log('handleBringPinToCenter')
        dispatchLatLng(center)
    }

    // const handleBackClick = (event) => {
    //     onBack(event)
    // }

    const dispatchLatLng = (newLatLng) => {
        dispatch({ type: 'markerLatLng', value: newLatLng })
    }

    useEffect(() => {
        if (!watchingLatLng) return
        // If the go to ICP Address default location || gps location not found 
        if ((watchingLatLng[0] === -35.73214300000001 && watchingLatLng[1] === 174.3095415) || (watchingLatLng[0] === -35.7464 && watchingLatLng[1] === 174.3094)) {
            setError(true)
        } else {
            setError(false)
        }

    }, [watchingLatLng])


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Typography variant="h4">ICP Location</Typography>
            <Typography variant="body2" paragraph>
                Move the map marker to the meter location.
                For residential properties the centre of the section is OK.
                For large rural properties and for new subdivisions
                please give an accurate location,
                e.g. by using the Goto My Location or Goto GPS Location button while you are on-site.
            </Typography>
            <MarkerControl sx={{ my: 2 }}
                latLng={markerLatLng}
                address={address}
                onLatLngChange={dispatchLatLng}
                onUseMyLocation={handleUseLocation}
                onBringPinToCenter={handleBringPinToCenter}
                formObject={useFormObject}
            />
            <Wrapper apiKey={envConfig.googleMapsAPIKey} render={render}>
                <GoogleMap
                    center={center}
                    // onClick={onClick}
                    onIdle={onIdle}
                    zoom={zoom}
                    style={{ height: "400px" }}
                >
                    {
                        markerLatLng
                        &&
                        <GoogleMapMarker key="m1" position={googleMapsLatLng} draggable={true} onDragEnd={(p) => dispatchLatLng({ lat: p.lat(), lng: p.lng() })} />
                    }
                </GoogleMap>
            </Wrapper>
            <Box sx={{ my: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="submit" variant="contained" disabled={error}>Next</Button>
            </Box>
            {
                (Object.keys(errors).length > 0 || error)
                &&
                <Box textAlign="right">
                    <Alert sx={{ display: 'inline-flex' }} severity="error">{error ? 'Location Error: Please relocate the marker to the correct address.' : 'Please set the ICP Location.'} </Alert>
                </Box>
            }

        </form>
    )
}

